import React, { useEffect, useState } from 'react';
import { ArrowRight, Code2, Sparkles } from 'lucide-react';
import { Button } from './ui/button';
import { personalInfo } from '../data/mock';

const Hero = () => {
  const [typedText, setTypedText] = useState('');
  const techStack = ['ReactJS', 'NextJS', 'Spring Boot', 'Java', 'MongoDB', 'NodeJS'];
  const [techIndex, setTechIndex] = useState(0);

  useEffect(() => {
    const currentTech = techStack[techIndex];
    let currentChar = 0;
    const typingInterval = setInterval(() => {
      if (currentChar <= currentTech.length) {
        setTypedText(currentTech.slice(0, currentChar));
        currentChar++;
      } else {
        clearInterval(typingInterval);
        setTimeout(() => {
          setTechIndex((prev) => (prev + 1) % techStack.length);
        }, 2000);
      }
    }, 100);

    return () => clearInterval(typingInterval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [techIndex]);

  const scrollToSection = (sectionId) => {
    const element = document.querySelector(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="min-h-screen flex items-center justify-center relative overflow-hidden pt-20">
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-72 h-72 bg-blue-500/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl animate-pulse delay-1000"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gradient-to-r from-blue-500/5 to-purple-500/5 rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-4xl mx-auto">
          <div className="backdrop-blur-sm bg-white/5 rounded-3xl p-8 md:p-12 border border-white/10 shadow-2xl">
            <div className="flex items-center space-x-2 mb-6 animate-fade-in">
              <Sparkles className="w-6 h-6 text-purple-400" />
              <span className="text-purple-400 font-medium">Available for opportunities</span>
            </div>

            <h1 className="text-5xl md:text-7xl font-bold mb-6 animate-fade-in">
              <span className="text-white">Hi, I'm </span>
              <span className="bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400 bg-clip-text text-transparent">
                {personalInfo.name}
              </span>
            </h1>

            <h2 className="text-2xl md:text-4xl text-gray-300 mb-6 font-light">
              {personalInfo.title}
            </h2>

            <div className="flex items-center space-x-3 mb-8 h-12">
              <Code2 className="w-6 h-6 text-blue-400" />
              <span className="text-xl text-gray-300">Specializing in:</span>
              <span className="text-xl font-semibold text-blue-400 min-w-[150px]">
                {typedText}
                <span className="animate-pulse">|</span>
              </span>
            </div>

            <p className="text-lg text-gray-400 mb-8 max-w-2xl leading-relaxed">
              {personalInfo.bio}
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                size="lg"
                className="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white font-semibold px-8 py-6 text-lg transition-all duration-300 hover:scale-105"
                onClick={() => scrollToSection('#projects')}
              >
                View My Work
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
              <Button
                size="lg"
                variant="outline"
                className="border-2 border-white/20 hover:border-white/40 bg-white/5 hover:bg-white/10 text-white font-semibold px-8 py-6 text-lg transition-all duration-300"
                onClick={() => scrollToSection('#contact')}
              >
                Contact Me
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-2 bg-white/50 rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;